<template>

	<!-- Contents-->
	<div class="container main">
		<div class="content">
			<div class="section" v-for="(value, key) in eduMainList" v-if="value.item.length > 0">
				<h2 class="tit_main">
					<router-link :to="'/app/education/main/' + value.code">{{ value.name }}</router-link>
				</h2>
				<ul class="gallery_list">
					<template v-for="(element, index) in value.item" v-if="index < 4">
						<li>
							<router-link :to="'/app/education/main/' + element.cateCode.slice(0, -2) + '?mode=learn&emIdx=' + element.emIdx">
								<figure class="list_thumb">
									<img v-if="element.thumbnail != null && element.thumbnail !== ''" :src="element.thumbnail" alt="" style="object-fit: cover; aspect-ratio: 1 / 1;">
									<img v-else src="/ssflex/assets/img/common/img_thumb.svg" alt="">
								</figure>
								<div class="list_text">
									<em class="cate">{{ element.cateCodeVO.codeName }}</em>
									<strong class="tit">{{ element.eduTitle }}</strong>
									<div class="desc">{{ element.introduce }}</div>
								</div>
							</router-link>
						</li>
					</template>
				</ul>
			</div>



			<div class="section" v-if="requestEduList.length > 0">
				<h2 class="tit_main">
					<router-link to="/app/education/mine/">학습중인 강좌</router-link>
				</h2>
				<ul class="gallery_list">
					<template v-for="(value, key) in requestEduList" >
						<li>
							<router-link :to="'/app/education/main/' + value.cateCode.slice(0, -2) + '?mode=learn&emIdx=' + value.emIdx">
								<figure class="list_thumb">
									<img v-if="value.thumbnail != null && value.thumbnail !== ''" :src="value.thumbnail" alt="" style="object-fit: cover; aspect-ratio: 1 / 1;">
									<img v-else src="/ssflex/assets/img/common/img_thumb.svg" alt="">
								</figure>
								<div class="list_text">
									<em class="cate">{{ value.cateCodeVO.codeName }}</em>
									<strong class="tit">{{ value.eduTitle }}</strong>
									<div class="desc">{{ value.introduce }}</div>
								</div>
							</router-link>
						</li>
					</template>
				</ul>
			</div>

			<div class="section">
				<h2 class="tit_main">
					최근 게시물
				</h2>
				<ul class="gallery_list">
					<li v-for="(item, index) in boardList">
						<router-link :to="'/app/board/' + item.boardKey + '?idx=' + item.idx">
							<figure class="list_thumb" v-if="true">
								<img v-if="item.thumbFile" :src="APIs.BOARD_FILES_SHOW + item.thumbFile.fidx" alt="" style="object-fit: cover; aspect-ratio: 1 / 1;">
								<img v-else src="/ssflex/assets/img/common/img_thumb.svg" alt="">
							</figure>
							<div class="list_text">
								<em class="cate">{{ item.cateName }}</em>
								<strong class="tit">{{ item.title }}</strong>
								<div class="desc">{{ item.contentText }}</div>
							</div>
						</router-link>
					</li>
				</ul>
			</div>
		</div>
	</div>

</template>

<script>
import $ from "jquery";
import Swiper from "../../../public/ssflex/assets/js/swiper.min";

export default {
	name: "cs1Main",
	data() {

		return {
			coAccountVO: {},
			rateCode: 0,

			mainBanners: [],
			subBanners: [],
			eduMainList: [],

			popupList: [],

			requestEduList: [],

			boardList: [],
			APIs: this.APIs,
		}
	},
	created() {
		this.getAccountRateCode()
		this.getRequestEduList();
		this.getMainData();
		this.recentBoardList();
		this.getUsePopupList();

		window.addEventListener('resize', this.handleResize);
	},
	mounted() {
	},
	updated() {
		/*this.$nextTick(() => {
			import('@/../public/assets/js/common-ui')
			this.handleResize();
		})*/
	},
	methods: {
		getAccountRateCode() {
			this.coAccountVO = this.getSessionProc();

		},
		handleResize() {
			// $('.main-ongoing').find('.swiper-slide').css('width', `${$('.main-update').find('.swiper-slide').css('width')}`)
			// $('.main-ongoing').find('.swiper-slide').css('margin-right', `${$('.main-update').find('.swiper-slide').css('margin-right')}`)
			// $('.main-latest').find('.desc').css('-webkit-line-clamp', `${(Math.ceil($('.main-latest').find('.thumb-box').eq(0).css('height').replace(/[^0-9, .]/g, "")) > 214 ? 4 : 3)}`)
		},
		getMainData() {
			this.eduMainList = {}

			const self = this
			self.axiosCaller.get(self, self.APIs.DISPLAY + "/main/", {eduCateCodeList: "200101"}, (res) => {

				const result = res.data
				if (result.status === "ok") {
					self.eduMainList = result.eduList;

					console.log("##### edu main #####")
					console.log(self.eduMainList)

				} else {
					console.log(result.msg)
				}

			})

		},


		getRequestEduList() {

			if (!this.isLogin()) {
				return;
			}

			this.requestEduList = []

			const self = this
			self.axiosCaller.get(self, self.APIs.DISPLAY + "/main/requestEduList", {
				page: 0,
				size: 10,
				sort: 'createDate,DESC',
				rateCode: this.rateCode,
			}, (res) => {

				const result = res.data

				if (result.status === "ok") {

					self.requestEduList = result.list
					self.$nextTick(() => {
						$(".main-ongoing .swiper-container").each(function () {
							new Swiper($(this), {
								slidesPerView: 4,
								spaceBetween: 24,
								navigation: {
									nextEl: ".main-ongoing .btn-next",
									prevEl: ".main-ongoing .btn-prev",
								},
								breakpoints: {
									991: {
										slidesPerView: 3,
										spaceBetween: 24,
									},
									767: {
										slidesPerView: 2.3,
										spaceBetween: 16,
									},
									575: {
										slidesPerView: 1.3,
										spaceBetween: 16,
									},
								},
							});
						});
					})
				} else {
					console.log(result.msg)
				}

			})

		},


		getUsePopupList() {

			this.popupList = []

			const self = this
			self.axiosCaller.get(self, self.APIs.DISPLAY_POPUP + "/getUsePopupList", {}, (res) => {

				const result = res.data

				if (result.status === "ok") {

					self.popupList = result.popupList
					this.$nextTick(() => {
						self.openPopup()
					})
				} else {
					console.log(result.msg)
				}

			})

		},


		openPopup () {

			const self = this

			let top = 0;
			let left = 0;
			self.popupList.forEach(list => {
				var cName = 'popup_' + list.idx;

				if(self.getCookie(cName) === null){
					this.$nextTick(() => {

						const url = self.APIs.BASE_URL + "/popup/" + list.idx + "?isLayout=false";
						const target = "new" + list.idx;
						const options = "width=" + list.sizeX + ",height=" + list.sizeY + ",top=" + top + ",left=" + left;
						this.appOpen({
							url: url,
							target: target,
							options: options,
						})

						if ( window.screenLeft >= 0 ) {
							left += list.sizeX
						} else {
							left -= list.sizeX * 2
						}
					})
				}

			});

		},


		recentBoardList() {

			const self = this
			this.boardList = []

			self.axiosCaller.get(self, self.APIs.DISPLAY + "/main/recentBoardList", {
				boardKeys: 'news_feeds,trend_events,success_examples,sw_examples,consulting_services,guide_function,site_notice',
				page: 0,
				size: 8,
				sort: 'createDate,DESC',
				isLogin: this.isLogin(),
				isUse: true
			}, (res) => {

				const result = res.data
				if (result.status === "ok") {

					self.boardList = result.list

				} else {
					console.log(result.msg)
				}

			})

		},


		goBoardView(_boardKey, _bidx) {
			this.webUtils.goTo(this, '/app/board/' + _boardKey + '/?idx=' + _bidx)
		},


		goLearning(_emIdx) {
			this.webUtils.goTo(this, '/app/education/main/?mode=learn&emIdx=' + _emIdx)
		},


	}
}
</script>

<style scoped>

</style>
